import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    // Altura "auto" em vez de fixa (era 430px, com overflow:scroll) - cortava
    // o conteúdo (Janela de pulverização, Temperatura, Previsão de chuva) com
    // uma barra de rolagem interna em vez de mostrar tudo.
    height: auto;
    padding: 16px;
    /* max-width: 350px; */

    gap: 12px;
    display: flex;
    flex-direction: column;
    align-items: ${props => props.NoContent ? 'center' : 'flex-start'};
    justify-content: ${props => props.NoContent ? 'center' : 'flex-start'};

    border-radius: 10px;
    background-color: ${theme.colors.white.Branco};

    // Sem overflow-x:auto aqui - só a fileira dos 5 cards de previsão
    // (ContainerPreviewDay, logo abaixo) tem scroll próprio no mobile; o
    // resto (Janela de pulverização, gráficos) espreme pra caber em vez de
    // rolar (ver @media max-width:760px nesses componentes).
    overflow-y: visible;

    >iframe {
        all: unset;
        width: 700px;
        min-width: 700px;
        height: 700px;
        border: none;
    }

    @media (max-width: 1309px) {
        max-width: 100%;

        align-items: center;
    }

    @media (max-width: 760px) {
        justify-content: flex-start;
        // "stretch" - no mobile, os filhos (Janela de pulverização, gráficos)
        // precisam ocupar a largura toda, sem sobrar espaço em branco do lado.
        align-items: stretch;
    }
`;

export const WidgetIframe = styled.iframe`
    all: unset;
    width: 100%;
    height: ${props => props.height || '400px'};
    border: none;
`;

export const ContainerContent = styled.div`
    width: 100%;
    height: auto;
    padding: 20px;

    gap: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    
    text-align: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }
`;

export const ContainerGraphicPreview = styled.div`
    // "100%" em vez de largura fixa (era 755px) - os gráficos usam
    // ResponsiveContainer width="100%" internamente, então encolhem junto
    // com o container de verdade, sem precisar de scroll horizontal.
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    flex-direction: column;

    @media (max-width: 760px) {
        // 100% (não mais largura fixa de 640px) - o gráfico (ResponsiveContainer)
        // só deve espremer no mobile, não rolar horizontal (mesma mudança em
        // weather-traffic-light/styles.js e rain-forecast-graphic/styles.js).
        width: 100%;
    }
`;

export const AddressInfo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ContainerPreviewDay = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    // Sem flex-wrap de propósito: a fileira rola horizontalmente quando não
    // cabe (ver nota do usuário) - quebrar linha deixava um espaço vazio feio
    // em vez de só rolar. Scroll próprio (não mais compartilhado com o
    // Container inteiro) - só essa fileira rola no mobile, o resto
    // (Janela de pulverização, gráficos) espreme pra caber.
    justify-content: flex-start;
    overflow-x: auto;

    /* width */
    ::-webkit-scrollbar {
        width: 3px;
        height: 3px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const ContainerContentGraphic = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 760px) {
        align-items: stretch;
    }
`;


export const PreviewDay = styled.div`
    width: 128px;
    flex-shrink: 0;
    height: auto;
    padding: 16px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    border-radius: 16px;
    border: 2px solid ${theme.colors.gray.Cinza_12};
    background-color: ${theme.colors.white.Branco};
`;

export const Day = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
`;

export const Preview = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
`;

export const PreviewModaInfo = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    flex-direction: column;

    >p {
        color: ${theme.colors.gray.Cinza_5};
    }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
    
  @keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  width: 50px;
  height: 50px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-bottom: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  animation: rotating 0.7s linear infinite;
`;